<template>
  <div class="addaddress">
    <div class="myspespace"></div>
    <div class="con">
      <van-field
        class="myfield"
        v-model="addresstext"
        rows="3"
        label=""
        type="textarea"
        placeholder="请粘贴或输入文本识别姓名、电话号码、地址"
        show-word-limit
      />
      <van-button class="readbtn" type="primary" @click="checkAddressData">识别</van-button>
    </div>
    <div class="con">
      <van-form>
        <van-field
          class="myvanfield"
          v-model="subdata.username"
          label="联系人:"
          placeholder="请填写姓名"
        />
        <van-field
          class="myvanfield"
          v-model="subdata.telephone"
          label="联系电话:"
          placeholder="请填写手机号"
        />
        <van-field
          class="myvanfield mylink"
          v-model="provinceCity"
          is-link
          label="所在地区:"
          placeholder="请选择省市区"
          @click="openCity"
        />
        <van-field
          class="myvanfield myvanfield2"
          v-model="subdata.adrdetail"
          label="详细地址:"
          rows="3"
          type="textarea"
          placeholder="请填写详细地址(如街道、小区、门牌号)"
        />
      </van-form>
    </div>
    <footer3 @subConFirm="subConFirm"></footer3>
    <citys ref="mycitys" @setCity="setCity"></citys>
  </div>
</template>

<script>
import footer3 from '../components/footer3'
import citys from '../components/citys'
import { addAddress, checkAddress, addressinfo, updateAddress } from '@/api/modules/address'
import { Toast } from 'vant'
export default {
  name: 'addexpress',
  components: {
    footer3, citys
  },
  data() {
    return {
      message: '',
      citys: [],
      addresstext: '',
      provinceCity: '',
      subdata: {
        username: '',
        telephone: '',
        province: '',
        city: '',
        county: '',
        adrdetail: '',
        is_def: 0
      }
    }
  },
  computed: {
  },
  created() {
    if(this.$route.query.address_id) {
      addressinfo({
        address_id: this.$route.query.address_id
      }).then((res) => {
        if (res.data.status_code === 200) {
          this.subdata.username = res.data.address.username
          this.subdata.telephone = res.data.address.telephone
          this.subdata.province = res.data.address.province
          this.subdata.city = res.data.address.city
          this.subdata.county = res.data.address.county
          this.subdata.adrdetail = res.data.address.adrdetail
          this.subdata.is_def = res.data.address.is_def
          this.provinceCity = this.subdata.province + '/' + this.subdata.city + '/' + this.subdata.county
        }
      })
    }
  },
  methods: {
    openCity() {
      console.log(this.$refs.mycitys)
      this.$refs.mycitys.setShow()
    },
    setCity(citys) {
      this.subdata.province = citys[0].name
      this.subdata.city = citys[1].name
      this.subdata.county = citys[2].name
      this.provinceCity = this.subdata.province + '/' + this.subdata.city + '/' + this.subdata.county
      this.citys = citys
    },
    checkAddressData() {
      if (!this.addresstext) {
        Toast('请输入地址')
        return
      }
      checkAddress({
        addresstext: this.addresstext
      }).then((res) => {
        if (res.data.succ === 'ok') {
          console.log(res.data.result.data)
          this.subdata.province = res.data.result.data.province
          this.subdata.city = res.data.result.data.city
          this.subdata.county = res.data.result.data.county
          this.subdata.adrdetail = res.data.result.data.detailaddr
          this.provinceCity = this.subdata.province + '/' + this.subdata.city + '/' + this.subdata.county
          this.$refs.mycitys.reset(res.data.result.data.adcode)
          if (res.data.result.paidata) {
            this.subdata.username = res.data.result.paidata.personName[0]
            this.subdata.telephone = res.data.result.paidata.phoneNumber
          }
        }
      })
    },
    subConFirm() {
      if (!this.subdata.username) {
        Toast('请输入联系人')
        return
      }
      if (!this.subdata.telephone) {
        Toast('请输入联系电话')
        return
      }
      if (!/^1\d{10}$/.test(this.subdata.telephone)) {
        Toast('请输入正确的联系电话')
        return
      }
      if (!this.provinceCity) {
        Toast('请选择省市区')
        return
      }
      if (!this.subdata.adrdetail) {
        Toast('请输入详细地址')
        return
      }
      // 编辑
      if (this.$route.query.address_id) {
        this.subdata.address_id = this.$route.query.address_id
        updateAddress({
          ...this.subdata
        }).then((res) => {
          if (res.status_code === 200) {
            Toast('更新成功')
            this.$router.back()
          }
        })
      }
      // 新增
      else {
        addAddress({
          ...this.subdata
        }).then((res) => {
          if (res.status_code === 200) {
            Toast('新增成功')
            this.$router.back()
          }
        })
      }

    }
  }
}
</script>
<style lang="less">
  .myfield{
    height:auto !important;
    .van-field__label{
      display:none;
    }
  }
  .addaddress{
    .van-field__control:disabled{
      -webkit-text-fill-color:#000000;
      color:#000000;
    }
    .myvanfield2{
      border-radius: 0px;
      height:250px;
    }
    .myvanfield{
      border-bottom:1px solid #eeeeee;
      input{
        text-align:left;
      }
    }
    .van-field--disabled{
      .van-field__label{
        color:#646566 !important;
      }
    }
    .mylink{
      .van-cell__right-icon{
        font-size:30px;
        line-height:56px;
      }
    }
  }
</style>
<style lang="less" scoped>
  .addaddress{
    min-height:100vh;
    background-color: #f4f5fb;
    .con{
      width: 720px;
      position:relative;
      background: #FFFFFF;
      border-radius: 20px;
      overflow:hidden;
      margin:0px 15px 15px 15px;
      .readbtn{
        position:absolute;
        right:30px;
        bottom:30px;
        font-weight: 400;
        font-size: 26px;
        color: #FFFFFF;
        line-height: 32px;
        background-color:#333333;
        border:1px solid #333333;
        border-radius:10px;
      }
    }
  }
</style>
